import { useEffect, useState } from "react";

const containerStyle = {
  border: "1px solid #D9D9D9",
  background: "#D9D9D9",
  width: "100%",
  height: "4px",
  borderRadius: "4px",
};

const contentStyle = {
  background: "blue",
  height: "4px",
  transition: "0.3s",
  borderRadius: "4px",
};

interface IProgressBar {
  max?: number;
  delay?: number;
}

export const ProgressBar = ({ max = 100, delay = 500 }: IProgressBar) => {
  const [percent, setPercent] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercent((prev) => {
        if (prev >= max) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, delay);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [max, delay]);

  return (
    <div style={containerStyle}>
      <div style={{ ...contentStyle, width: `${percent}%` }}></div>
    </div>
  );
};
